import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setItemInCart } from "./redux/cart/cartSlice";
import { toast } from "react-toastify";
import { CSSTransition } from "react-transition-group";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

function Chair({ chair }) {
  const dispatch = useDispatch();
  const { itemInCart } = useSelector((state) => state.cart);
  const [showAddedToCart, setShowAddedToCart] = useState(false);

  const addInCart = () => {
    const exists = itemInCart.some((item) => item.id === chair.id);
    if (exists) {
      toast.info("Бул нерсе себетте мурунтан бар");
      return;
    }

    dispatch(setItemInCart(chair));
    setShowAddedToCart(true);
    setTimeout(() => setShowAddedToCart(false), 1500);

    if (window.fbq) {
      window.fbq("track", "AddToCart", {
        content_name: chair.title,
        content_ids: [chair.id],
        content_type: "product",
        value: chair.price,
        currency: "KGS",
      });
    }
  };

  const handleScrollToTop = () => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 300);
  };

  return (
    <div className="bg-[#FAF9F6] rounded-[28px] overflow-hidden">
      {/* Image */}
      <Link to={`/chair/${chair.id}`} onClick={handleScrollToTop}>
        <div className="relative">
          <img
            src={chair.img}
            alt={chair.title}
            loading="lazy"
            decoding="async"
            width="400"
            height="300"
            className="w-full h-full object-cover rounded-[28px]"
          />
        </div>
      </Link>

      {/* Content */}
      <div className="px-5 pt-4 pb-6">
        {/* Price */}
        <p className="text-sm font-medium text-gray-900 mb-1">
          {chair.price} сом
        </p>

        {/* Title */}
        <Link to={`/chair/${chair.id}`} onClick={handleScrollToTop}>
          <h3 className="text-xl font-semibold text-black leading-snug mb-2">
            {chair.title}
          </h3>
        </Link>

        {/* Description */}
        <p className="text-gray-600 text-sm leading-relaxed mb-5">
          {chair.description || ""}
        </p>

        {/* Button */}
        <button
          onClick={addInCart}
          className="group relative overflow-hidden flex items-center justify-between
             bg-[#A1C349] hover:bg-[#beda76] transition
             text-white text-sm font-medium
             px-5 py-2.5 rounded-full w-[180px]"
        >
          <span className="absolute left-1 flex items-center justify-center w-8 h-8 bg-white text-black rounded-full transition-all duration-500 group-hover:left-[calc(100%-2.2rem)]">
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </span>
          {/* Text */}
          <span
            className="absolute right-5 flex gap-[1px]
               transition-all duration-300
               group-hover:opacity-0 group-hover:-translate-x-4"
          >
            {"Сатып алуу".split("").map((char, i) => (
              <span key={i}>{char === " " ? "\u00A0" : char}</span>
            ))}
          </span>

          {/* Animated text (right side) */}
          <span
            className="flex gap-[1px] opacity-0
               group-hover:opacity-100
               group-hover:translate-x-0
               translate-x-4 transition-all duration-300"
          >
            {"Сатып алуу".split("").map((char, i) => (
              <span
                key={i}
                style={{ transitionDelay: `${i * 40}ms` }}
                className="inline-block transition-all duration-300
                   opacity-0 translate-y-2
                   group-hover:opacity-100 group-hover:translate-y-0"
              >
                {char === " " ? "\u00A0" : char}
              </span>
            ))}
          </span>

          {/* Arrow */}
        </button>

        <CSSTransition
          in={showAddedToCart}
          timeout={200}
          classNames="fade-in"
          unmountOnExit
        >
          <p className="mt-3 text-sm text-lime-600">✔ Себетке кошулду</p>
        </CSSTransition>
      </div>
    </div>
  );
}

export default Chair;
